import React from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@ui/components/Modal'

import { useHomePageUrl } from '@hooks/useHomePageUrl'

interface Props {
  onCancel: () => void
  onConfirm: () => void
  title: string
  message: string
}
export const PasswordRestrictionMessageModal: React.FC<Props> = ({
  onCancel,
  onConfirm,
  title,
  message,
}) => {
  const { t } = useTranslation()

  const homePageUrl = useHomePageUrl()

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{message}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={onConfirm}>{t('Got It')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            window.open(
              `${homePageUrl}/about/contact-us`,
              '_blank',
              'location=yes,height=570,width=520,scrollbars=yes,status=yes'
            )
            onCancel()
          }}
        >
          {t('Contact support')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
